import { render, staticRenderFns } from "./tenderResult.vue?vue&type=template&id=b24bdca0&"
import script from "./tenderResult.vue?vue&type=script&lang=js&"
export * from "./tenderResult.vue?vue&type=script&lang=js&"
import style0 from "./tenderResult.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports